import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Ban } from "lucide-react";
import { http } from "../lib/api";

export const BannedWords = () => {
  const [value, setValue] = useState("");
  const [count, setCount] = useState(0);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    http.get("/admin/banned-words").then((r) => {
      const w = Array.isArray(r.data?.words) ? r.data.words : [];
      setValue(w.join("\n"));
      setCount(w.length);
    }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const words = value.split(/[\n,]/).map((w) => w.trim()).filter(Boolean);
      const r = await http.put("/admin/banned-words", { words });
      const saved = r.data?.words ?? [];
      setValue(saved.join("\n"));
      setCount(saved.length);
      toast.success(`${saved.length} palavra(s) bloqueada(s)`);
    } catch {
      toast.error("Falha ao salvar a lista");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mb-10 border border-white/5 bg-[#0d0c11] p-5" data-testid="banned-words">
      <p className="flex items-center gap-2 text-white"><Ban size={16} className="text-rose-500" /> Palavras bloqueadas <span className="font-mono-d text-xs text-slate-400">({count})</span></p>
      <p className="mb-3 mt-1 text-xs text-slate-400">Uma por linha (ou separadas por vírgula). Comentários com essas palavras no nome ou no texto são recusados automaticamente, sem email e sem aviso ao visitante. Maiúsculas e acentos são ignorados.</p>
      <textarea rows={4} value={value} onChange={(e) => setValue(e.target.value)} placeholder={"spam\nlink-golpe\npalavrão"} className="w-full border border-slate-800 bg-black px-3 py-2 font-mono-d text-xs text-white outline-none focus:border-rose-500" data-testid="banned-words-input" />
      <button onClick={save} disabled={saving} className="mt-3 bg-rose-600 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-white hover:bg-rose-500 disabled:opacity-50" data-testid="banned-words-save">
        {saving ? "Salvando..." : "Salvar lista"}
      </button>
    </div>
  );
};
